import styled from "@emotion/styled";
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { buildLoomEmbedUrl } from "./learning-center-data";
import CloseIcon from "@mui/icons-material/Close";
import { LearningCenterVideo } from "./learning-center.store";
import { useCallback, useState } from "react";

type Props = {
  video: LearningCenterVideo | null;
  onClose: () => void;
};

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: -0.5rem;
  left: 0;
  z-index: 0;
`;

const CustomDialogTitle = styled(DialogTitle)`
  margin-right: 2rem;

  ${(p) => p.theme.media.mobileDown} {
    font-size: ${(p) => p.theme.title.fontSizes.h6};
  }
`;

const CustomDialogContent = styled(DialogContent)`
  position: relative;
  width: 100%;
  overflow: hidden;
  aspect-ratio: 640 / 370;
  border-radius: 1rem;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 1rem;
    z-index: 1;
  }
`;

export const OpenedVideoDialog = (props: Props) => {
  const { video, onClose } = props;
  const [isLoading, setIsLoading] = useState(true);

  const handleClose = useCallback(() => {
    onClose();
    setIsLoading(true);
  }, [onClose]);

  return (
    <Dialog open={!!video} maxWidth="lg" fullWidth onClose={handleClose}>
      <CustomDialogTitle>
        <span>{video?.title}</span>
        <IconButton
          sx={{ position: "absolute", right: "1rem", top: "1rem" }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </CustomDialogTitle>
      <CustomDialogContent>
        {isLoading && (
          <LoaderContainer>
            <CircularProgress />
          </LoaderContainer>
        )}
        {!!video && (
          <iframe
            src={buildLoomEmbedUrl(video.id)}
            allow="fullscreen"
            onLoad={() => setIsLoading(false)}
          />
        )}
      </CustomDialogContent>
    </Dialog>
  );
};
